const Error404Page = () => {
  return (
    <div>
      <h1 className="my-2">404 Error</h1>
      <p>The page you requested could not be found.</p>
    </div>
  );
};

export default Error404Page;
